// extracted by mini-css-extract-plugin
export default {"dashboardMonthlyActivity":"DashboardMonthlyActivity-module__dashboardMonthlyActivity--oCtJS"};